import React from 'react';
import { Mail, Phone, Calendar, User, Trash2 } from 'lucide-react';

const DELETE_BTN_STYLE = {
  marginLeft: 'auto',
  background: 'transparent',
  border: '1px solid rgba(239,68,68,0.4)',
  color: '#ef4444',
  cursor: 'pointer',
  padding: '4px 10px',
  borderRadius: '8px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '0.8rem',
};

const ContactCard = ({ contact, formatDate, onOpen, onToggleStatus, onDelete }) => (
  <div
    className={`contact-card ${contact.status} clickable`}
    onClick={() => onOpen(contact)}
  >
    <div className="contact-header">
      <div className="contact-sender">
        <User size={18} />
        <span className="sender-name">{contact.name}</span>
        <span
          className={`status-badge ${contact.status} clickable-badge`}
          onClick={(e) => onToggleStatus(contact, e)}
          title={`Click to mark as ${contact.status === 'unread' ? 'read' : 'unread'}`}
        >
          {contact.status}
        </span>
      </div>
      <div className="contact-date">
        <Calendar size={14} />
        {formatDate(contact.created_at)}
      </div>
    </div>
    <div className="contact-subject">
      <strong>Subject:</strong> {contact.subject}
    </div>
    <div className="contact-message-preview">
      {contact.message.length > 100
        ? `${contact.message.substring(0, 100)}...`
        : contact.message}
    </div>
    <div className="contact-footer" onClick={(e) => e.stopPropagation()}>
      <a href={`mailto:${contact.email}`} className="contact-link">
        <Mail size={14} /> {contact.email}
      </a>
      {contact.phone && (
        <a href={`tel:${contact.phone}`} className="contact-link">
          <Phone size={14} /> {contact.phone}
        </a>
      )}
      <button
        type="button"
        onClick={(e) => onDelete(contact, e)}
        title="Delete this message"
        data-testid={`delete-contact-${contact.id}`}
        style={DELETE_BTN_STYLE}
      >
        <Trash2 size={14} /> Delete
      </button>
    </div>
  </div>
);

export default ContactCard;
